import { render, staticRenderFns } from "./GroupComparisonChart.vue?vue&type=template&id=518e01ce&scoped=true"
import script from "./GroupComparisonChart.vue?vue&type=script&lang=js"
export * from "./GroupComparisonChart.vue?vue&type=script&lang=js"
import style0 from "./GroupComparisonChart.vue?vue&type=style&index=0&id=518e01ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e01ce",
  null
  
)

export default component.exports